export default __webpack_public_path__ + "static/media/uiDesignConsistency.1c0ba120.md";